export default "__VITE_ASSET__Bk7j_sN0__"